const SECOND_MS = 1_000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;

/**
 * French, human-readable duration of an interview recording, coarsened to the largest two units
 * that keep the figure readable — hours and minutes, or minutes alone, or seconds alone. `null`
 * (a duration that failed to be captured, `OutboxPort.ts`) renders an explicit sentence rather than
 * an empty string, so the missing figure is never mistaken for a recording that lasted no time at
 * all.
 */
const formatDuration = (durationMs: number | null): string => {
	if (durationMs === null) {
		return 'Durée inconnue';
	}

	const totalSeconds = Math.round(durationMs / SECOND_MS);

	if (totalSeconds < 60) {
		return `${totalSeconds} s`;
	}

	const totalMinutes = Math.floor(durationMs / MINUTE_MS);

	if (durationMs < HOUR_MS) {
		return `${totalMinutes} min`;
	}

	const hours = Math.floor(durationMs / HOUR_MS);
	const remainingMinutes = Math.round((durationMs % HOUR_MS) / MINUTE_MS);

	return `${hours} h ${remainingMinutes.toString().padStart(2, '0')}`;
};

export default formatDuration;
